import { useRichTextEditor } from '../../providers';

import ControlButton from './control-button';

export interface RichTextEditorInsertLatexShortcutControlProps {
  /**
   * Display label rendered inside the toolbar button (e.g. "β").
   */
  label: string;
  /**
   * Accessible label / tooltip text.
   */
  ariaLabel: string;
  /**
   * Raw LaTeX source to insert when the button is clicked.
   */
  latex: string;
}

/**
 * A toolbar button that inserts a fixed LaTeX snippet via the `insertLatex`
 * Tiptap command. Used for quick-insert shortcuts (e.g. \beta, \sigma).
 */
function RichTextEditorInsertLatexShortcutControl(
  props: Readonly<RichTextEditorInsertLatexShortcutControlProps>,
) {
  const { label, ariaLabel, latex } = props;
  const { editor } = useRichTextEditor();

  if (!editor) {
    return null;
  }

  return (
    <ControlButton
      aria-label={ariaLabel}
      title={ariaLabel}
      data-rich-text-editor-control
      onClick={() => {
        editor.chain().focus().insertLatex(latex).run();
      }}
    >
      <span style={{ fontFamily: 'serif', fontStyle: 'italic', fontSize: 14 }}>{label}</span>
    </ControlButton>
  );
}

export function BetaControl() {
  return (
    <RichTextEditorInsertLatexShortcutControl
      label='β'
      ariaLabel='Insert beta (\beta)'
      latex={String.raw`\beta`}
    />
  );
}

export function SdControl() {
  return (
    <RichTextEditorInsertLatexShortcutControl
      label='σ'
      ariaLabel='Insert sigma / SD (\sigma)'
      latex={String.raw`\sigma`}
    />
  );
}

export function SummationControl() {
  return (
    <RichTextEditorInsertLatexShortcutControl
      label='Σ'
      ariaLabel='Insert summation (\sum)'
      latex={String.raw`\sum`}
    />
  );
}

export default RichTextEditorInsertLatexShortcutControl;
